import { IonContent } from '@ionic/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { amplitudeModule } from '@/modules/amplitude';
import { OnboardingFooter } from '@/pages/Onboarding/components/Footer';
import { OnboardingTitle } from '@/pages/Onboarding/components/Title';
import { useOnboarding } from '@/pages/Onboarding/context';
import { canLogEvents } from '@/utils/canLogEvents';

import { LayoutDataType } from '../../types';

import { ReplikaChatExampleStyles } from './ChatExample.styles';

const chatTitleByTopicIdMap: Record<
  NonNullable<LayoutDataType['topics']>,
  string
> = {
  support:
    'Anytime, any way you like – text, photo, or video, she is here to support you 🙌',
  romantic:
    'Text, photo, or video - she’s just a message away anytime you want 💦',
  talks:
    'Anytime, any way you like – text, photo, or video, she’s here for deep and meaningful talks 💫',
  roleplay:
    'Roleplay like never before – text, video, photos, and unexpected turns 😉',
  'explore-ai':
    'Explore endless AI capabilities in text, photo and video formats 🔥',
};

export const OnboardingReplikaChatExample: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'ChatExample',
      });
    }
  }, []);

  const { watch } = useFormContext<LayoutDataType>();

  const topic = watch('topics') || 'romantic';

  const { wizard } = useOnboarding();

  const handleNextStep = (): void => {
    wizard.nextStep();
  };

  return (
    <ReplikaChatExampleStyles>
      <IonContent>
        <div className="img-container">
          <img
            src={`https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/chat-by-topic/${topic}.png`}
            alt="chat"
            onError={(e) => {
              e.currentTarget.src =
                'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/chat-by-topic/romantic.png';
            }}
          />
        </div>
        <OnboardingTitle className="onboarding-chat-example__title">
          {chatTitleByTopicIdMap[topic]}
        </OnboardingTitle>
      </IonContent>

      <OnboardingFooter onContinue={handleNextStep} />
    </ReplikaChatExampleStyles>
  );
};
